import Vue from 'vue';
import moment from 'moment';
/**
 * Register Vue properties
 */
export const registerProperties = () => {
    Object.defineProperty(Vue.prototype, '$moment', { value: moment });
};
